"use client"
/* */
const avatarColors = [
  "blue",
  "teal",
  "green",
  "violet",
  "lilac"
];

export { avatarColors };
//# sourceMappingURL=avatarColors.mjs.map
